<template>
  <div class="container">
    <HeadTitle title="用户服务"></HeadTitle>
    <div class="body">
      <div v-if="isIorg"
        class="item"
        @click="
          $router.push({
            name: 'WorkerSubmit',
            query: {
              organizationId,
              category
            }
          })
        "
      >
        <div class="title">新用户注册</div>
        <img src="@/assets/images/icon-server-user.png" alt="" />
      </div>
      <div v-if="!isIorg" class="item" @click="isShowSubmitDialog = true">
        <div class="title">新用户注册</div>
        <img src="@/assets/images/icon-server-user.png" alt="" />
      </div>
      <div
        class="item"
        @click="
          $router.push({
            name: 'AuthUser',
            query: {
              organizationId,
              category
            }
          })
        "
      >
        <div class="title">手机号变更</div>
        <img src="@/assets/images/icon-server-phone.png" alt="" />
      </div>
    </div>

    <!-- 用户选择 -->

    <van-dialog
      v-model="isShowSubmitDialog"
      class="submit-dialog"
      :show-confirm-button="false"
      close-on-click-overlay
    >
      <template #title>选择身份</template>
      <template>
        <div class="content">
          <div
            class="item"
            @click="
              $router.push({
                name: 'StudentSubmit',
                query: {
                  organizationId
                }
              })
            "
          >
            <div class="title">我是学生</div>
            <img src="@/assets/images/icon-submit-student.png" alt="" />
          </div>
          <div
            class="item"
            @click="
              $router.push({
                name: 'WorkerSubmit',
                query: {
                  organizationId,
                  category
                }
              })
            "
          >
            <div class="title">我是职工</div>
            <img src="@/assets/images/icon-submit-teacher.png" alt="" />
          </div>
        </div>
      </template>
    </van-dialog>
  </div>
</template>

<script>
import HeadTitle from '@/components/headTitle';
export default {
  name: '',
  components: { HeadTitle },
  data() {
    return {
      isShowSubmitDialog: false,
      organizationId: '',
      category: '',
      isIorg: false
    };
  },
  created() {
    this.isIorg = process.env.VUE_APP_BASE_API === 'https://iorg.zhonghezhihui.com/api';
    if (this.$route.query.organizationId) {
      this.organizationId = this.$route.query.organizationId;
    }
    if (this.$route.query.category) {
      this.category = this.$route.query.category;
    }
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;

  .body {
    flex: 1;
    padding: 118px 16px 0px 16px;

    .item {
      width: 343px;
      height: 130px;
      border-radius: 10px;
      opacity: 1;
      background: #ffffff;
      box-shadow: 0 0 15px 0 #00000014;
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      padding: 0 40px;
      box-sizing: border-box;
      justify-content: space-between;
      .title {
        color: #333333;
        font-size: 18px;
        font-weight: 500;
      }
      img {
        width: 60px;
        height: 60px;
      }
    }
  }
  .submit-dialog {
    width: 343px;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 0 16px;
    ::v-deep .van-dialog__header {
      padding: 20px 0 0 0;
      text-align: left;
      color: #666666;
      font-size: 14px;
      font-weight: 400;
      font-family: '苹方';
    }
    .content {
      display: flex;
      flex-direction: column;
      padding-bottom: 10px;
      margin-top: 24px;
      .item {
        width: 311px;
        height: 100px;
        border-radius: 10px;
        opacity: 1;
        background: #ffffff;
        box-shadow: 0 0 15px 0 #00000014;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 20px 40px;
        margin-bottom: 20px;
        .title {
          color: #333333;
          font-size: 18px;
          font-weight: 500;
        }
        img {
          width: 60px;
          height: 60px;
        }
      }
    }
  }
}
</style>
